import { Button } from "@mui/material";
import React from "react";
import "../../CSS/Hero.css";

type Props = {};

const Hero = (props: Props) => {
  return (
    <div
      className="flex flex-col items-center justify-center text-center p-4 md:p-10 space-y-4 md:space-y-6 bg-white rounded-lg"
      style={{ backgroundColor: "rgba(217, 217, 217, 1)", overflowX: "hidden" }}
      data-aos="fade-up"
    >
      <h1
        className="text-3xl md:text-5xl font-bold mb-4 w-11/12 md:w-3/5"
        style={{ color: "rgba(69, 72, 57, 1)" }}
      >
        Join <span style={{ color: "rgba(93, 120, 89, 1)" }}>Eco Pack</span> in
        transforming waste into rescources.
      </h1>
      <p
        className="mb-6 text-sm md:text-base w-11/12 md:w-1/2"
        style={{ color: "rgba(89, 86, 86, 1)" }}
      >
        We collect your recyclable items and give them a new life, creating a
        sustainable future for everyone.
      </p>
      <Button
        variant="contained"
        className="learn-more-button"
        sx={{
          backgroundColor: "rgba(138, 154, 91, 1)",
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255, 1)",
            color: "rgba(138, 154, 91, 1)",
          },
          borderRadius: "50px",
          padding: "10px 20px",
          fontSize: "16px",
        }}
      >
        Learn More{" "}
        <img
          src={require("../../Assets/arrow.png")}
          alt="arrow"
          className="ml-2 arrow-icon"
          style={{ width: "5vmin" }}
        />
      </Button>
      <img
        src={require("../../Assets/truck.png")}
        alt="Truck"
        className="w-1/2 mt-6"
        id="truck-image"
      />
    </div>
  );
};

export default Hero;
